import { GridSmartViewsWebComponent } from './component/GridSmartViewsWebComponent';
import { WEB_COMPONENT_GRID_SMART_VIEWS } from '../../webcomponents.constants';

export { GridSmartViewsWebComponent };

window.customElements.define(WEB_COMPONENT_GRID_SMART_VIEWS, GridSmartViewsWebComponent);
